import { render } from "./RelationSVMSummaryCard.vue?vue&type=template&id=6dc3d1ad"
import script from "./RelationSVMSummaryCard.vue?vue&type=script&lang=js"
export * from "./RelationSVMSummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__